import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@wix/design-system';
import { useResponsiveComponents } from '../../../hooks/useResponsiveComponents';
import { TFormField, TFormActions } from '../../../reducers/formStateReducer';
import { FormInput } from '../../FormInput/FormInput';
import {
  getOnlyIntgerValue,
  isFieldEmpty,
  validateFieldLength,
} from '../validators';
import InfoIcon from 'wix-ui-icons-common/InfoCircleSmall';

export const InvoiceNumberField: React.FC<{
  setState: React.Dispatch<TFormActions>;
  value: TFormField;
}> = ({ value: invoiceNumber, setState }) => {
  const { t } = useTranslation();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [Responsive] = useResponsiveComponents();

  const validateField = () =>
    !isFieldEmpty('invoiceNumber', invoiceNumber) &&
    !validateFieldLength('invoiceNumber', invoiceNumber)
      ? setState({
          type: 'fieldError',
          value: { fieldName: 'invoiceNumber', hasError: true },
        })
      : setState({
          type: 'fieldError',
          value: { fieldName: 'invoiceNumber', hasError: false },
        });

  return (
    <FormInput
      dataHook="invoice-number"
      value={invoiceNumber.value}
      onBlur={validateField}
      status={invoiceNumber.hasError ? 'error' : undefined}
      statusMessage={t(
        'charge-locator.charge_locator_form.field_error.invalid_invoice_number',
      )}
      suffix={
        <Responsive.Tooltip
          isOpen={isTooltipOpen}
          onCancel={() => setIsTooltipOpen(false)}
          content={t(
            'charge-locator.charge-locator-form.invoice-number-tooltip',
          )}
        >
          <Box color="B10" marginLeft="SP1">
            <InfoIcon size="18px" onClick={() => setIsTooltipOpen(true)} />
          </Box>
        </Responsive.Tooltip>
      }
      onChange={(e) => {
        return setState({
          type: 'invoiceNumber',
          value: getOnlyIntgerValue({ value: e?.target?.value, maxLength: 10 }),
        });
      }}
      label={t('charge-locator.charge-locator-form.invoice-number')}
    />
  );
};
